import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, Slide, Typography, Box, IconButton } from '@mui/material';
import { TransitionProps } from '@mui/material/transitions';
import React from 'react';
import icon from '../assets/quanto_custa_about.png';
import dcc_ufmg from '../assets/Logo-DCC-UFMG-Fundo-Claro.png';
import { Close } from '@mui/icons-material';



type Props = {
    open: boolean,
    onClose: (() => void)
}

function Abaut({ open, onClose }: Props) {

    return (<Dialog
        open={open}
        keepMounted
        onClose={onClose}
        aria-describedby="alert-dialog-slide-description"
    >
        <DialogTitle sx={{ bgcolor: '#f5f2f2' }}>
            <img src={icon} style={{ height: "60px" }} />
            <IconButton
                aria-label="close"
                onClick={onClose}
                sx={{
                    position: 'absolute',
                    right: 20,
                    top: 25,
                }}
            >
                <Close sx={{ color: "primary" }} />
            </IconButton>
        </DialogTitle>
        <DialogContent sx={{ textAlign: 'center', m: 4 }}>
            <Typography variant="h6" color="initial" sx={{ mb: 4 }}>Desenvolvido por:</Typography>
            <img src={dcc_ufmg} />
            <Box sx={{ mt: 4 }}>
                <p>Quanto Custa: v{process.env.REACT_APP_VERSION}</p>
            </Box>
        </DialogContent>
    </Dialog>);
}

export default Abaut;
